import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PlantationOneCertificate from "./PlantationOneCertificate";
import "./PlantationOneAdoptATree.scss";

const PlantationOneAdoptATree = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const scrollWrapperRef = useRef(null);

  const purposes = [
    {
      id: 6,
      title: "Memory of a Loved-one",
      description: "A tree is a living tribute to honor and remember someone special forever.",
      image:
        "/assets/img/greenify/image3333.jpg",
    },
    {
      id: 7,
      title: "Celebrating Milestones",
      description: "Celebrate life’s special moments by planting a tree that grows with your memories.",
      image:"/assets/img/greenify/image33331.jpg",
    },
    {
      id: 8,
      title: "Legacy and Future Generations",
      description: "Leave a green legacy that benefits future generations just like our ancestors did.",
      image:"/assets/img/greenify/image33332.jpg",
    },
    {
      id: 9,
      title: "Community Building",
      description: "Unite communities through tree planting and shared responsibility for nature.",
      image:"/assets/img/greenify/image33333.webp",
    },
    {
      id: 10,
      title: "Aesthetic Value",
      description: "Enhance the beauty of your surroundings with lush, life-giving trees.",
      image:"/assets/img/greenify/image33334.jpg",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCertificate, setShowCertificate] = useState(false);
  const [userData, setUserData] = useState({
    userName: "Kunika Gera", // Replace with actual user data
    totalOrders: 3 // Replace with actual order count
  });

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex >= purposes.length - 3 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? purposes.length - 3 : prevIndex - 1
    );
  };

  const handleAdoptClick = () => {
    navigate("/products-two");
  };

  
  const handleShowCertificate = () => {
    setShowCertificate(true);
  };

  const handleCloseCertificate = () => {
    setShowCertificate(false);
  };

  // Smooth scroll to section
  useEffect(() => {
    if (location.state?.scrollTo === 'adopt-purpose-section') {
      const element = document.getElementById("adopt-purpose-section");
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });

        navigate('.', { replace: true, state: {} });
      }
    }
  }, [location.state, navigate]);

  // Auto-rotate carousel (desktop)
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  // Auto-scroll mobile scroll container
  useEffect(() => {
    const container = scrollWrapperRef.current;
    if (!container) return;

    const scrollStep = () => {
      const cardWidth = container.firstChild?.offsetWidth || 0;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (container.scrollLeft + cardWidth >= maxScrollLeft) {
        container.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: cardWidth + 20, behavior: 'smooth' }); // 20 is gap
      }
    };

    const interval = setInterval(scrollStep, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="adopt-purpose-section" className="plantation-adopt-tree-final">
      <div className="nature-container">
        {/* Text Header Stack */}
        <div className="text-stack">
          <p className="nature-subheading">
            <span>WHY ADOPT A TREE</span>
            <div className="nature-subheading__underline nature-subheading__underline--center"></div>
          </p>
          <h2 className="nature-heading">Meaningful Reasons to Adopt</h2>
          <p className="nature-text">
            Each tree adoption celebrates life's special moments while helping
            restore our planet.
          </p>
        </div>

        {/* Desktop Carousel */}
        <div className="desktop-carousel">
          <button className="carousel-arrow prev" onClick={prevSlide}>
            &lt;
          </button>

          <div className="cards-container">
            {purposes.slice(currentIndex, currentIndex + 3).map((purpose) => (
              <div className="purpose-card" key={purpose.id}>
                <div className="card-image">
                  <img src={purpose.image} alt={purpose.title} />
                </div>
                <div className="card-content">
                  <h3>{purpose.title}</h3>
                  <p>{purpose.description}</p>
                  <button className="adopt-button" onClick={handleAdoptClick}>
                    Adopt Now <span>→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-arrow next" onClick={nextSlide}>
            &gt;
          </button>
        </div>

        {/* Mobile Horizontal Scroll */}
        <div className="mobile-scroll-container">
          <div className="cards-scroll-wrapper" ref={scrollWrapperRef}>
            {purposes.map((purpose) => (
              <div className="purpose-card" key={purpose.id}>
                <div className="card-image">
                  <img src={purpose.image} alt={purpose.title} />
                </div>
                <div className="card-content">
                  <h3>{purpose.title}</h3>
                  <p>{purpose.description}</p>
                  <button className="adopt-button" onClick={handleAdoptClick}>
                    Adopt Now <span>→</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Share Achievement Button */}
        {/* <div className="share-achievement-container">
          <button className="share-achievement-btn" onClick={handleShowCertificate}>
            Share Your Achievement
          </button>
        </div> */}
      </div>

      {/* Certificate Modal */}
     {showCertificate && (
  <div className="certificate-modal-overlay" onClick={handleCloseCertificate}>
    <div
      className="certificate-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button className="close-modal-btn" onClick={handleCloseCertificate}>
        ×
      </button>
      <div className="certificate-wrapper">
        <PlantationOneCertificate 
          userName={userData.userName} 
          totalOrders={userData.totalOrders} 
        />
      </div>
    </div>
  </div>
)}

    </section>
  );
};

export default PlantationOneAdoptATree;